import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {injectable} from "inversify";
import BeforeDatabasePreparedEvent from "@/modules/database/events/BeforeDatabasePreparedEvent";
import {initDataSource} from "@/modules/main-menu/services/db";
import {Capacitor} from '@capacitor/core';
import {sqliteConnection} from "@/modules/database/services/db";

@injectable()
export class DatabaseEventSubscriber implements EventSubscriber {
  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeDatabasePreparedEvent, callback: this.onBeforeDatabasePreparedEvent},
    ];
  }

  priority(): number {
    return 0;
  }

  async onBeforeDatabasePreparedEvent(event: BeforeDatabasePreparedEvent): Promise<void> {
    const platform = Capacitor.getPlatform();

    const dataSource = await initDataSource();

    if (!dataSource.isInitialized) {
      await dataSource.initialize();
    }

    await dataSource.runMigrations();

    if (platform === 'web') {
      await sqliteConnection.saveToStore(dataSource.name);
    }
  }
}
